import Print from 'apollo-react-icons/Print';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { downloadAllAttachments } from '../../actions/AttachmentsDownloadAction';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import {
  getFormInfo,
  getNetworkStatus,
  getToken,
  getWorkflowInfo,
  makeGetEntityPropertyValue,
} from '../../form-designer/selectors/common.selectors';
import { getEnvVar } from '../../utils/env';
import MenuButton from '../MenuButton';

const PrintButton = ({ entityType, filterMenuItem }) => {
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const recordNumber = useFormSelector(makeGetEntityPropertyValue, {
    propertyName: 'RecordNumberColumn',
  });
  const recordRevision = useFormSelector(makeGetEntityPropertyValue, {
    propertyName: 'RecordRevisionColumn',
  });
  const token = useFormSelector(getToken);
  const formInfo = useFormSelector(getFormInfo);
  const workflowInfo = useFormSelector(getWorkflowInfo);
  const isOnline = useSelector(getNetworkStatus);

  const rptName = `${formInfo?.formEntityKey}_DETAIL`;
  const entityName = workflowInfo?.entityType;
  const itmId = workflowInfo?.itmId;

  const menuItems = [
    {
      text: translateString('Detail'),
      id: 'DETAIL',
      onClick: () => {
        window.open(
          `${getEnvVar(
            'REACT_APP_ADMIN_APP_URL'
          )}/SmartReport.aspx?RptName=${rptName}&RECORD_NUMBER=${encodeURIComponent(
            recordNumber
          )}${`&RECORD_REVISION=${encodeURIComponent(recordRevision ?? '')}`}&Token=${token}`,
          '_blank'
        );
      },
    },
    {
      text: translateString('Download All Attachments'),
      id: 'DOWNLOAD_ALL_ATTACHMENTS',
      onClick: () => {
        dispatch(downloadAllAttachments({ entityName, itmId }));
      },
    },
  ];

  const filteredItems = filterMenuItem ? menuItems.filter(filterMenuItem(entityType)) : menuItems;

  return (
    <MenuButton
      icon={Print}
      buttonText={translateString('Print')}
      menuItems={filteredItems}
      disabled={!isOnline}
    />
  );
};

export default PrintButton;
